import * as React from "react";
import { useState } from "react";
import Button from "@mui/material/Button";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import Avatar from "@mui/material/Avatar";
import { DialogContent } from "@mui/material";
import IconView from "../../Contents/FontIcons/IconView";
import Verification from "../Verification";
import Badge from '@mui/material/Badge';
import { Getrequest } from "../../../../context/AxiosRequest";
import { ContextData } from "../../../../context/Context";
import Disbursement from "../Disbursement";

export default function DisbursementStatusListDialogue(props) {

  const [open, setOpen] = React.useState(false);
  const {type,Bgcolor,name} = props;
  const {accesstoken} = React.useContext(ContextData)
  const [Counts,setCounts] = useState("0")

   
  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false); 
  };



  // Get List of Qualification from the server

  React.useEffect(() => {
           
              (async()=>{

                      const response = await Getrequest("/auth/count_applicantBio_for_Qualification_type",accesstoken)
                        
                        if(response){

                          if(type === "returned_by_approver"){


                             if(response?.returned_by_approver !== 0){
                                setCounts(response?.returned_by_approver)
                             }else{
                                setCounts("0")  
                             }

                          }else  if(type === "return"){

                              if(response?.Returned !== 0){
                                setCounts(response?.Returned)
                             }else{
                                setCounts("0")
                             }

                          
                          }  

                        }
                    
              })()
  }, []);
 
  return (
    <div className="appicant-profile-dialog-con w-500rem ">
       
       <Badge color="secondary" badgeContent={Counts} max={2000} overlap="circular">

         <Button sx={{backgroundColor:Bgcolor, marginRight:"1em"}} variant="contained" onClick={handleClickOpen}>
         <span>{type === "returned_by_approver" ? "Applications Returned by Approver" : type + ""}  </span>
        <IconView
          tooltipText="View Applicants Profile"
          tooltipColor="white"
          tooltipIconSize="19px"
        />
      </Button>

      </Badge>
    
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        fullWidth
        maxWidth=""
      >
        <DialogContent>
       
              
              <Disbursement applincntNumbr={Number(Counts).toLocaleString()} params={type} name={name} type="DisbursementStatusListDialogue" />

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          {/* <Button onClick={handleClose} autoFocus>
            Agree
          </Button> */}
        </DialogActions>
      </Dialog>
    </div>
  );
}
